import {useEffect, useState} from 'react';
import {reaction} from 'mobx';
import {useGetUserSettingsHook} from '@/../generated/src/GetUserSettings/get.hook';
import {userStore} from '@/shared/stores/userStore';

// Volgt userStore.isSignedIn als React-state. De componenten die dit gebruiken
// zijn geen MobX-observers, dus zonder dit komt de wissel van uitgelogd naar
// ingelogd niet door.
const useIsSignedIn = () => {
    const [isSignedIn, setIsSignedIn] = useState(userStore.isSignedIn);

    useEffect(
        () => reaction(() => userStore.isSignedIn, setIsSignedIn, {fireImmediately: true}),
        [],
    );

    return isSignedIn;
};

export const useUserSettings = () => {
    // Niet ophalen zonder ingelogde gebruiker. De interceptor in axiosClient zet
    // het token van userManager.getUser() op de call; zonder gebruiker mislukt
    // die, en SWR probeert het pas na 5 tot 15 seconden opnieuw. Sinds de login
    // client-side navigeert (#6566) mount React al op /callback, vóór de login
    // rond is. Het menu bleef dan seconden leeg, en op een beheer-URL toonde de
    // routebewaking intussen "niet bevoegd".
    const isSignedIn = useIsSignedIn();
    const {isLoading, data} = useGetUserSettingsHook(undefined, {shouldFetch: isSignedIn});

    return {
        isLoading,
        data: data?.data,
    };
};
